import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useWebCourses } from '../hooks/sectionHooks';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LoadingSpinner from '../components/LoadingSpinner';
import '../App.css';

function Courses() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { data: webCoursesData, isLoading, error } = useWebCourses();
  
  // Get selected type from URL params (default to 'ALL')
  const selectedType = searchParams.get('type') || 'ALL';

  // Filter courses based on selected type
  const filteredCourses = selectedType === 'ALL' 
    ? webCoursesData 
    : Array.isArray(webCoursesData) 
      ? webCoursesData.filter(course => course.course_type === selectedType)
      : [];
  
  // Group courses by type for rendering
  const cfaCourses = Array.isArray(filteredCourses)
    ? filteredCourses
        .filter(course => course.course_type === 'CFA')
        .sort((firstCourse, secondCourse) =>
          Number(/танхим/i.test(secondCourse.name || '')) -
          Number(/танхим/i.test(firstCourse.name || ''))
        )
    : [];
  const fypCourses = Array.isArray(filteredCourses) ? filteredCourses.filter(course => course.course_type === 'FYP') : [];
  
  // Determine which sections to show
  const showCFA = selectedType === 'ALL' || selectedType === 'CFA';
  const showFYP = selectedType === 'ALL' || selectedType === 'FYP';

  return (
    <div className="App">
      <Header />

      {/* Main Content */}
      <main className="courses-page-new">
        {isLoading && <LoadingSpinner />}
        {error && <p style={{ textAlign: 'center', padding: '2rem', color: 'red' }}>Error loading courses.</p>}
        
        {/* CFA Courses Section */}
        {showCFA && cfaCourses.length > 0 && (
          <section className="courses-section-new">
            <div className="courses-section-header">
              <h2 className="courses-section-title">CFA Сургалтууд</h2>
              {/* <Link to="/courses?type=CFA" className="all-courses-btn">БҮХ СУРГАЛТУУД</Link> */}
            </div>
            <div className="courses-grid-new">
              {cfaCourses.map((course) => (
                <div key={course.id} className="course-card-new" onClick={() => navigate(`/course/${course.id}`)}>
                  <div className="course-card-image">
                    {course.icon && (
                      <img src={course.icon} alt={course.name} loading="lazy" />
                    )}
                  </div>
                  <div className="course-card-content">
                    <h3 className="course-card-title">{course.name}</h3>
                    <div className="course-card-desc-full" dangerouslySetInnerHTML={{ __html: course.description }} />
                    <div className="course-card-footer">
                      <div className="course-level">
                        <span className="level-icon">📊</span>
                        <span>{course.level || 'Бүх түвшин'}</span>
                      </div>
                      {course.price && (
                        <div className="course-price-tag">
                          {course.price.toLocaleString()}₮
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* CFA Video Section */}
        {/* {showCFA && (
          <section className="cfa-video-section-new">
            <div className="cfa-video-container-new">
              <div className="cfa-video-wrapper-new">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/LWPGead00mE"
                  title="CFA Program Orientation"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </section>
        )} */}

        {/* CFA Bottom Banner */}
        {/* {showCFA && (
          <section className="courses-banner-section">
            <div className="courses-banner-container">
              <img 
                src="https://edu-icer.mn/wp-content/uploads/2025/05/904d1-web-cover.png" 
                alt="CFA Banner"
                className="courses-banner-image"
              />
            </div>
          </section>
        )} */}

        {/* FYP Courses Section */}
        {showFYP && fypCourses.length > 0 && (
          <section className="courses-section-new courses-section-alt-new">
            <div className="courses-section-header">
              <h2 className="courses-section-title">FYP Сургалтууд</h2>
              {/* <Link to="/courses?type=FYP" className="all-courses-btn">БҮХ СУРГАЛТУУД</Link> */}
            </div>
            <div className="courses-grid-new">
              {fypCourses.map((course) => (
                <div key={course.id} className="course-card-new" onClick={() => navigate(`/course/${course.id}`)}>
                  <div className="course-card-image">
                    {course.icon && (
                      <img src={course.icon} alt={course.name} loading="lazy" />
                    )}
                  </div>
                  <div className="course-card-content">
                    <h3 className="course-card-title">{course.name}</h3>
                    <div className="course-card-desc" dangerouslySetInnerHTML={{ __html: course.description }}></div>
                    <div className="course-card-footer">
                      <div className="course-level">
                        <span className="level-icon">📊</span>
                        <span>{course.level || 'Бүх түвшин'}</span>
                      </div>
                      {course.price && (
                        <div className="course-price-tag">
                          {course.price.toLocaleString()}₮
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* FYP Info Section */}
        {showFYP && (
          <section className="fyp-intro-section-new">
            <div className="fyp-intro-container-new">
              <p className="fyp-intro-text-new">
                FYP хөтөлбөр нь мэргэжилтэн, байгууллагын бүтээмжийг сайжруулахад төвлөрсөн практик болон зөөлөн ур чадварын богино сургалтын сан юм.
              </p>
              
              <h3 className="fyp-intro-heading-new">Хөтөлбөрийн гол үйл цэн нь:</h3>
              <ul className="fyp-intro-list-new">
                <li>Ажлын байранд шууд ашиглах боломжтой суурь, зөөлөн, практик ур чадвар;</li>
                <li>Мэдлэгдэхүйц ажлын бүтээмжийн өсөлт;</li>
                <li>Хэрэглээнд тохирсон (customized) чанартай сургалтын арга зүй.</li>
              </ul>

              <p className="fyp-contact-text-new">
                FYP хөтөлбөрийн талаар дэлгэрэнгүй мэдээлэл авах бол <strong>info@icer.mn</strong> хаягаар холбогдоно уу.
              </p>
            </div>
          </section>
        )}

        {/* FYP Bottom Banner */}
        {/* {showFYP && (
          <section className="courses-banner-section">
            <div className="courses-banner-container">
              <img 
                src="https://edu-icer.mn/wp-content/uploads/2025/11/ICER-Web-Cover-01-1.png" 
                alt="FYP Banner"
                className="courses-banner-image"
              />
            </div>
          </section>
        )} */}
      </main>

      <Footer />
    </div>
  );
}

export default Courses;
